<!-- 人员分组操作 -->
<template>
	<div>
		<el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle" :close-on-click-modal="false" append-to-body center  width="60%" top="2rem">
			<el-form size="mini" label-width="150px" label-position="right" :show-message="false">
				<el-form-item label="分组编码" prop="opgCode" :rules="[{required: true, trigger: ['blur', 'change']}]">
					<el-input v-model="sendDataInfo.opgCode" maxlength="30"></el-input>
				</el-form-item>
				<el-form-item label="分组名称" prop="opgName" :rules="[{required: true, trigger: ['blur', 'change']}]">
					<el-input v-model="sendDataInfo.opgName"  maxlength="30"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==0">保存</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==1">保存</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name:'userGroupAction',
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
				openMode:'ltr'||'rtl',
				boxTitle:'新增'||'编辑',
				actionType:0, // 0新增，1修改
			},
			sendDataInfo: {
				opgCode: '',
				opgName:'',
				opgId:'',
			},
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
	},
    //方法集合
    methods: {
		
		initActionBox(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key]  = ''
			}
			this.sendDataInfo.opgCode = this.$common.createUserGroupCode()
			
			this.dataActionBox.actionType = 0
			this.dataActionBox.showStatus = false
		},
		

		
		openBox(cate,oldData=''){
			console.log(cate)
			this.initActionBox()
			if(cate == 0){
				this.dataActionBox.boxTitle = '新增信息'
				this.dataActionBox.openMode = 'ltr'
			}else{
				this.dataActionBox.boxTitle = '编辑信息'
				this.dataActionBox.openMode = 'rtl'
				for(let key in oldData){
					this.sendDataInfo[key]  = oldData[key]
				}
			
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
			
		},
		async sendDataAction(){
			if(this.sendDataInfo.opgCode==''){
				this.$message({
					message: '请填写编码',
					type: 'error'
				});
				return false
			}
			if(this.sendDataInfo.opgName==''){
				this.$message({
					message: '请填写名称',
					type: 'error'
				});
				return false
			}
			var sendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo))
			if(this.dataActionBox.actionType==0){
				var responseData =  await this.$http.addUserGroup(sendDataInfo)
			}else{
				var responseData =  await this.$http.editUserGroup(sendDataInfo)
			}
			if(responseData.status == 200){
				this.initActionBox()
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				
				this.$parent.getDataList()
				
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
	
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box{
	height: 200px;
	background-color: red;
}
.table_content_box{
	height: 500px !important;
	overflow-y: auto;
}
</style>